import { render } from "./SaveQualificationLanguage.vue?vue&type=template&id=19f68ff1"
import script from "./SaveQualificationLanguage.vue?vue&type=script&lang=js"
export * from "./SaveQualificationLanguage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/thabangteddy/Downloads/orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__